/**
 * Collection Toolbar — Moon Moon
 * Gere le selecteur de vue desktop (densite de la grille). La vue choisie est persistee
 * globalement (localStorage) pour survivre a la pagination et aux changements de page.
 * Fallback : defaut de la collection (MF collection > setting > 3).
 * Mobile : grille fixe en 2 colonnes (data-view-mobile rendu en Liquid), pas de selecteur.
 */
(function () {
    // Cle localStorage : preference de vue globale (tout le site, pas par collection)
    const STORAGE_KEY = 'mm-collection-view-desktop';

    function getStoredView(min, max, fallback) {
        let stored;
        try {
            stored = parseInt(localStorage.getItem(STORAGE_KEY), 10);
        } catch (e) {
            stored = NaN;
        }
        if (stored >= min && stored <= max) return stored;
        return fallback;
    }

    function storeView(cols) {
        try {
            localStorage.setItem(STORAGE_KEY, cols);
        } catch (e) {
            /* localStorage indisponible (mode prive) : la vue reste valable pour la page courante */
        }
    }

    function init() {
        const toolbar = document.querySelector('[data-collection-toolbar]');
        const grid = document.querySelector('[data-collection-grid]');
        if (!toolbar || !grid) return;

        // Vue effective : preference persistee (globale) > defaut collection (MF > setting > 3).
        const defaultDesktop = parseInt(toolbar.dataset.viewDefaultDesktop, 10) || 3;
        const currentDesktop = getStoredView(3, 5, defaultDesktop);

        applyView(grid, currentDesktop);
        syncButtons(toolbar, currentDesktop);

        // Detection sticky : sentinelle 1px au-dessus du toolbar pour toggler .mm-stuck
        const sentinel = document.createElement('div');
        sentinel.setAttribute('aria-hidden', 'true');
        sentinel.style.cssText = 'width:1px;height:1px;pointer-events:none;';
        toolbar.insertAdjacentElement('beforebegin', sentinel);
        const observer = new IntersectionObserver(
            ([entry]) => toolbar.classList.toggle('mm-stuck', !entry.isIntersecting),
            { threshold: 0 }
        );
        observer.observe(sentinel);

        toolbar.addEventListener('click', (event) => {
            const btn = event.target.closest('[data-view-cols]');
            if (!btn) return;
            const cols = parseInt(btn.dataset.viewCols, 10);
            if (!cols) return;
            applyView(grid, cols);
            syncButtons(toolbar, cols);
            storeView(cols);
        });

        // Titre dynamique + mm-active selon l'URL courante
        const h1 = document.querySelector('.mm-hero-collection__title');
        const links = toolbar.querySelectorAll('.mm-collection-toolbar__categories-link[data-label]');
        if (h1 && links.length) {
            h1.dataset.originalTitle = h1.textContent.trim();
            const currentParams = new URLSearchParams(window.location.search);
            let matched = false;
            links.forEach(link => {
                const url = new URL(link.href);
                const linkParams = new URLSearchParams(url.search);
                const isSamePath = url.pathname === window.location.pathname;
                const isSameParams = linkParams.toString() === currentParams.toString();
                // Entree « tout » : reste active quand des filtres ajoutent des parametres
                const isAllLink = link.hasAttribute('data-collection-all');
                if (isSamePath && (isSameParams || isAllLink)) {
                    h1.textContent = link.dataset.label;
                    link.classList.add('mm-active');
                    matched = true;
                } else {
                    link.classList.remove('mm-active');
                }
            });
            if (!matched) {
                h1.textContent = h1.dataset.originalTitle;
            }
        }

        // Scroll automatique animé vers le lien actif sur mobile
        const mobileNav = document.querySelector('.mm-collection-toolbar__categories--mobile');
        if (mobileNav) {
            requestAnimationFrame(() => {
                const activeLink = mobileNav.querySelector('.mm-collection-toolbar__categories-link.mm-active');
                if (activeLink) {
                    const navCenter = mobileNav.offsetWidth / 2;
                    const linkCenter = activeLink.offsetLeft + activeLink.offsetWidth / 2;
                    mobileNav.scrollTo({
                        left: linkCenter - navCenter,
                        behavior: 'smooth'
                    });
                }
            });
        }
    }

    function applyView(grid, cols) {
        grid.dataset.viewDesktop = cols;
        forceGridReflow(grid);
    }

    /**
     * Safari (WebKit) ne recalcule pas le placement `grid-auto-flow: dense`
     * quand `grid-template-columns` et le `grid-column` des cards editoriales
     * (1 / -1 <-> auto) changent dynamiquement : la grille reste "cassee"
     * (colonnes fausses, cards qui debordent) jusqu'a un reload.
     * On force un reflow synchrone via un toggle de `display` pour que le
     * moteur re-execute le placement. Chrome/Firefox ne sont pas affectes
     * mais le toggle y est inoffensif.
     */
    function forceGridReflow(grid) {
        const previous = grid.style.display;
        grid.style.display = 'none';
        /* Lecture forcant le reflow (grid detachee du layout) */
        void grid.offsetHeight;
        grid.style.display = previous;
    }

    function syncButtons(toolbar, cols) {
        const buttons = toolbar.querySelectorAll('[data-view-cols]');
        buttons.forEach((btn) => {
            const active = parseInt(btn.dataset.viewCols, 10) === cols;
            btn.classList.toggle('mm-active', active);
            btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
